export default {"src":"/_next/static/media/Banner_button.14e63c35.gif","height":110,"width":364,"blurWidth":0,"blurHeight":0};